import { useState, useEffect } from 'react';

/**
 * Hook for fetching domain settings for current selected domains
 * @param {{ value: number; className: string }[]} domains - Array of domain objects from the domains dropdown
 * @param {boolean} showInactive - Determines whether or not backend should return locations for inactive groups
 */
export default function useDomainSettings(domains, showInactive) {
  const [domainSettings, setDomainSettings] = useState({
    isAutomotiveIndustry: false,
    isTextingEnabled: false,
    prospectCallTypes: ['Prospect'],
    industryType: 'Other',
    isLoading: true,
  });

  useEffect(() => {
    if (!domains) {
      return;
    }

    let body = {
      group_ids: [],
      location_ids: [],
      show_inactive: showInactive,
    };
    domains.forEach((item) => {
      if (item.className.includes('filter-group')) {
        body.group_ids.push(item.value);
      } else if (item.className.includes('filter-location')) {
        body.location_ids.push(item.value);
      }
    });

    fetch('/reports/domain_info', {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then(({ isAutomotiveIndustry, isTextingEnabled, prospectCallTypes, industryType }) => {
        if (!industryType) {
          industryType = 'Other';
        }
        setDomainSettings({
          isAutomotiveIndustry,
          isTextingEnabled,
          prospectCallTypes,
          industryType,
          isLoading: false,
        });
      });
  }, [domains, showInactive]);

  return domainSettings;
}
